import { AuthenticationModule, ConfigLoader, LocalStorageLoader } from '@airtradeit/authentication';
import { LoginPageModule } from '@airtradeit/login-page';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { PrivateRoutesModule } from '@pages/private-routes.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { AuthConfigLoaderService } from '@shared/services/auth-config-loader/auth-config-loader.service';
import { AuthService } from '@shared/services/auth/auth.service';
import { ContentfulService } from '@shared/services/contentful/contentful.service';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initGTM } from './app.gtm.setup';
import { RaygunErrorHandler } from './app.raygun.setup';
import { GlobalConstant } from './core/constants/global.constant';
import { AppInitializerFactory } from './core/factories/app-initializer/app-initializer';
import { TransLoaderFactory } from './core/factories/translate-loader/translate-loader.factory';
import { AuthInterceptor } from './core/interceptors/auth/auth.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/http-error/http-error.interceptor';
import { AppStoreModule } from './core/store/app-store.module';
import { PagesModule } from './pages/pages.module';
import { ComponentsModule } from './shared/components/components.module';
import { ConfigService } from './shared/services/config/config.service';
import { ServicesModule } from './shared/services/services.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    PrivateRoutesModule,
    AppRoutingModule,
    PipesModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TransLoaderFactory,
        deps: [ContentfulService],
      },
    }),
    AuthenticationModule.forRoot({
      configServiceLoader: {
        provide: ConfigLoader,
        useFactory: (configService: ConfigService) => new AuthConfigLoaderService(configService),
        deps: [ConfigService],
      },
      localStorageLoader: {
        provide: LocalStorageLoader,
        useFactory: () => new LocalStorageService(),
      },
    }),
    LoginPageModule.forRoot({ appName: 'My <strong>Fare</strong>Finder' }),
    DeviceDetectorModule.forRoot(),
    CollapseModule.forRoot(),
    PopoverModule.forRoot(),
    AppStoreModule,
    ServicesModule,
    ComponentsModule,
    PagesModule
  ],
  providers: [
    GlobalConstant,
    {
      provide: APP_INITIALIZER,
      useFactory: initGTM,
      multi: true,
      deps: [ConfigService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: AppInitializerFactory,
      multi: true,
      deps: [ConfigService, AuthService, Router, LocalStorageService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useClass: RaygunErrorHandler,
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
